// extracted by mini-css-extract-plugin
export default {"statsSection":"StatsSection_statsSection__HyYO1"};